import {AppAction} from "../../DefaultSettings/Store/types";
import {PartnerDashboardActionTypes} from "./actionTypes";
import {UserWithCustomer} from "../Models/UserWithCustomer";
import {FilterAccountStatus} from "./types";
import { OrderFilterEnum } from '../OrderFilterEnum';


export type SetDeleteModal = (userToDelete: UserWithCustomer | null) => AppAction<UserWithCustomer | null>;
export type SetEdit = (userToEdit: UserWithCustomer) => AppAction<UserWithCustomer>;
export type SetNew = (defaultValues: UserWithCustomer) => AppAction<UserWithCustomer>;
export type SelectLdap = (selected: boolean) => AppAction<boolean>;
export type FormReset = (key: string) => AppAction<string>;
export type SetSendNewPasswordModal = (sendNewPassword: UserWithCustomer | null) => AppAction<UserWithCustomer | null>;

export type FilterSearch = (search: string) => AppAction<string>;
export type FilterRole = (role: number[]) => AppAction<number[]>;
export type FilterCustomer = (customer: number[]) => AppAction<number[]>;
export type FilterStatus = (status: FilterAccountStatus) => AppAction<FilterAccountStatus>;
export type FilterOrder = (order: OrderFilterEnum) => AppAction<OrderFilterEnum>;


export const setDeleteModal: SetDeleteModal = (userToDelete) => ({
  type: PartnerDashboardActionTypes.SET_DELETE_MODAL,
  payload: userToDelete
});

export const setEdit: SetEdit = (userToEdit) => ({
  type: PartnerDashboardActionTypes.SET_EDIT,
  payload: userToEdit
})

export const setNew: SetNew = (defaultValues) => ({
  type: PartnerDashboardActionTypes.SET_NEW,
  payload: defaultValues
})

export const selectLdap: SelectLdap = (selected) => ({
  type: PartnerDashboardActionTypes.SELECT_LDAP,
  payload: selected
})

export const formReset: FormReset = (key) => ({
  type: PartnerDashboardActionTypes.FORM_RESET,
  payload: key
});

export const setSendNewPasswordModal: SetSendNewPasswordModal = (sendNewPassword) => ({
  type: PartnerDashboardActionTypes.SEND_NEW_PASSWORD,
  payload: sendNewPassword
});

export const filterSearch: FilterSearch = (search) => ({
  type: PartnerDashboardActionTypes.FILTER_SEARCH,
  payload: search
})

export const filterRole: FilterRole = (role) => ({
  type: PartnerDashboardActionTypes.FILTER_ROLE,
  payload: role
})

export const filterCustomer: FilterCustomer = (customer) => ({
  type: PartnerDashboardActionTypes.FILTER_CUSTOMER,
  payload: customer
})

export const filterStatus: FilterStatus = (status) => ({
  type: PartnerDashboardActionTypes.FILTER_STATUS,
  payload: status
})

export const filterOrder: FilterOrder = (order) => ({
  type: PartnerDashboardActionTypes.FILTER_ORDER,
  payload: order
})
